module.exports = __webpack_public_path__ + "media/images/front/pc/institution-treatment-information/img_doctor01-a3717a72709e0e482524493becbc19de.jpg";